<template>
  <div class="m-during-area null-padd">
    <div class="c-video-timeline">
      <div
        v-for="agenda in agendaList"
        :key="agenda.agendaId"
        v-bind:id="agenda.id"
        v-bind:class="{ hover: agenda.isShow }"
        class="video-node"
        v-bind:style="{ left: agenda.percent + '%' }"
      >
        <div class="bottom-bar"></div>
        <div class="node-info left-limit">
          <div class="node-close" v-on:click="closeTimeLine">
            <span class="icon icontemp stemp-close"></span>
          </div>
          <div class="node-tit" :title="agenda.theme">
            {{ agenda.theme }}
          </div>
          <div class="node-con" v-for="(f, i) in agenda.fileList" :key="i">
            <div class="con-txt" :title="f.name">
              {{ f.name }}
            </div>

            <div class="con-img" v-on:click="downloadFile(f.id)" title="下载">
              <span class="icon icontemp download"></span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { $subscriber, cr } from "fire-wind-water";
import moment from "moment";
import webinar from "./../../services/webinar";

export default {
  name: "TimeLine",
  data() {
    return {
      agendaList: []
    };
  },
  mounted() {},
  created() {
    this.init();
  },
  methods: {
    init() {
      let self = this;
      $subscriber.subscribe("webinarInfo", data => {
        let webinarStartTime = data.startTime / 1000;
        let webinarEndTime = data.endTime / 1000;
        let webinarTimeLength = webinarEndTime - webinarStartTime;
        let agendaList = cr.extend(true, {}, data.agendaList);
        cr.each(agendaList, (d, i) => {
          d.isShow = false; //i===0;
          d.endTimeDate = moment(d.endTime * 1000).format("HH:mm");
          d.startTimeDate = moment(d.startTime * 1000).format("HH:mm");
          let id = parseInt(i) + 1;
          d.id = "timeline" + id;
          let agendaGuestNames = [];
          cr.each(d.agendaGuest, a => {
            agendaGuestNames.push(a.name);
          });
          d.agendaGuestName = agendaGuestNames.join(",");
          d.percent =
            ((d.startTime - webinarStartTime) * 100) / webinarTimeLength;
          d.fileList = d.resources;
        });
        self.agendaList = agendaList;
      });
      $subscriber.subscribe("onTimeline", this.onTimeLineSingle);
      $subscriber.subscribe("fileList", data => {
        for (let a in self.agendaList) {
          if (self.agendaList[a].fileList.length > 0) {
            let list = [];
            for (let f in self.agendaList[a].fileList) {
              for (let m in data.content.items) {
                if (
                  self.agendaList[a].fileList[f] == data.content.items[m].fileId
                ) {
                  list.push({
                    id: self.agendaList[a].fileList[f],
                    name:
                      data.content.items[m].name +
                      "." +
                      data.content.items[m].ext
                  });
                }
              }
            }
            self.agendaList[a].fileList = list;
          }
        }
      });
      // $subscriber.subscribe('onTimelineSingle', this.onTimeLineSingle);
    },
    onTimeLineSingle(data) {
      cr.each(this.agendaList, d => {
        d.isShow = d.id === data.content;
      });
    },
    closeTimeLine() {
      this.onTimeLineSingle({ content: { data: { content: "closexxx" } } });
    },
    testSocket() {
      this.onTimeLineSingle({ content: { data: { content: "timeline1" } } });
    },
    downloadFile(fileId) {
      webinar.getFileInfo({ fileId: fileId }).subscribe(data => {
        window.open(data.content.fileUrl);
      });
      //https://t-content.smarket.net.cn/index.php?mappingId=c41b72dc275db6009edcab9fd15f8025&type=download&isPreview=1
      // alert(fileId);
    }
  }
};
</script>

<style scoped></style>
